import * as React from "react";
import {Cell, Label, Pie, PieChart} from "recharts";
import {getDataCompletionChartData} from "./informUtil";

export interface IDataCompletionDonutChartProps {
    completion: string | undefined
}

export const DataCompletionDonutChart: React.FunctionComponent<IDataCompletionDonutChartProps> = (props) => {
    const outerRadius = 90;
    const innerRadius = 75;
    const renderChart = (value: string | undefined) => {
        const data = getDataCompletionChartData(value);
        return <div className="data-completion__chart">
            <PieChart width={outerRadius*2} height={outerRadius*2}>
                <Pie data={data} dataKey="value" nameKey="name" startAngle={90} endAngle={-270}
                     innerRadius={innerRadius} outerRadius={outerRadius}>
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color}/>
                    ))}
                    <Label width={30} position="center" content={(labelProps: any) => {
                        const {viewBox} = labelProps;
                        const cx = viewBox?.cx ?? 0;
                        const cy = viewBox?.cy ?? 0;
                        return (
                            <text textAnchor="middle">
                                <tspan x={cx + 95} y={cy + 80} className="data-completion__chart-label">
                                    {`${data[0].value.toString()}%`}
                                </tspan>
                                <tspan x={cx + outerRadius} y={cy + 105} className="data-completion__label">Data</tspan>
                                <tspan x={cx + outerRadius} y={cy + 122} className="data-completion__label">Completion</tspan>
                            </text>
                        );
                    }}/>
                </Pie>
            </PieChart>
        </div>;
    };

    return props.completion
        ? <div className="data-completion__container" data-testid="data-completion__container">
            {renderChart(props.completion)}
        </div>
        : null;
};